/**
 * * 로딩 중 페이지
 */
import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

interface IProps {
  isLoading?: boolean;
}
const LoadingPage: React.FC<IProps> = ({ isLoading }) => {
  return (
    <Container isLoading={isLoading}>
      <Spin size={'large'} />
      <p className='loading'>잠시만 기다려주세요.</p>
    </Container>
  );
};

export default LoadingPage;

const Container = styled.div`
  .ant-spin-spinning {
    background: rgba(87, 87, 87, 0.7);
    display: ${(props) => (props.isLoading === true ? '' : 'none')};
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .ant-spin-dot-spin {
    position: absolute;
    top: 40%;
    left: 45%;
    transform: translate(-50, -50);
    z-index: 1000;
  }
  .loading {
    color: white;
    font-weight: 800;
    font-size: 15px;
    position: absolute;
    top: 48%;
    left: 43%;
    transform: translate(-50, -50);
    z-index: 1000;

    display: ${(props) => (props.isLoading === true ? '' : 'none')};
  }
`;
